import React from "react";

const WebsiteCMSIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.9341,21.03v-10.97c0,-1.14 -0.9186,-2.06 -2.0419,-2.06h-13.7844c-1.1274,0 -2.0419,0.93 -2.0419,2.06v10.97h-1.5659v2.02c0,1.08 0.8685,1.95 1.9292,1.95h17.1416c1.0648,0 1.9292,-0.88 1.9292,-1.95v-2.02zM8.1056,10.06c0,-0.55 0.4468,-1.01 0.998,-1.01h13.7844c0.5512,0 0.998,0.46 0.998,1.01v10.97h-15.7845v-10.97zM25.4561,23.05c0,0.49 -0.3967,0.9 -0.8853,0.9h-17.1416c-0.4886,0 -0.8853,-0.41 -0.8853,-0.9v-0.96h7.4996v0.25c0,0.25 0.2046,0.46 0.4593,0.46h3.0027c0.2506,0 0.4594,-0.2 0.4594,-0.46v-0.25h7.4995v0.96z"
        fill="currentColor"
      />
      <path
        d="M13.8773,14.57c-0.0061,0.12 -0.1043,0.22 -0.227,0.22h-0.6503c0.0613,-0.96 0.5767,-1.79 1.3374,-2.29c-0.2515,0.58 -0.4172,1.28 -0.4601,2.07z"
        fill="#1A8B5A"
      />
      <path
        d="M14.9816,12.18c0.2577,-0.09 0.5276,-0.16 0.8098,-0.17v2.55c0,0.13 -0.1043,0.23 -0.2331,0.23h-1.0246c-0.1349,0 -0.2454,-0.11 -0.2331,-0.24c0.0614,-0.96 0.3129,-1.8 0.681,-2.37z"
        fill="#1A8B5A"
      />
      <path
        d="M17.0184,12.18c0.3681,0.57 0.6196,1.41 0.681,2.37c0.0061,0.13 -0.0982,0.24 -0.2331,0.24h-1.0246c-0.1288,0 -0.2331,-0.1 -0.2331,-0.23v-2.55c0.2822,0.01 0.5521,0.08 0.8098,0.17z"
        fill="#1A8B5A"
      />
      <path
        d="M19,14.79h-0.6503c-0.1227,0 -0.2209,-0.1 -0.227,-0.22c-0.0429,-0.79 -0.2086,-1.49 -0.4601,-2.07c0.7607,0.5 1.2761,1.33 1.3374,2.29z"
        fill="#1A8B5A"
      />
      <path
        d="M13.6503,15.21c0.1227,0 0.2209,0.1 0.227,0.22c0.0429,0.79 0.2086,1.49 0.4601,2.07c-0.7607,-0.5 -1.2761,-1.33 -1.3374,-2.29z"
        fill="#1A8B5A"
      />
      <path
        d="M15.5583,15.21c0.1288,0 0.2331,0.1 0.2331,0.23v2.55c-0.2822,-0.01 -0.5521,-0.08 -0.8098,-0.17c-0.3681,-0.57 -0.6196,-1.41 -0.681,-2.37c-0.0061,-0.13 0.0982,-0.24 0.2331,-0.24z"
        fill="#1A8B5A"
      />
      <path
        d="M17.6994,15.45c-0.0614,0.96 -0.3129,1.8 -0.681,2.37c-0.2577,0.09 -0.5276,0.16 -0.8098,0.17v-2.55c0,-0.13 0.1043,-0.23 0.2331,-0.23h1.0246c0.1349,0 0.2454,0.11 0.2331,0.24z"
        fill="#1A8B5A"
      />
      <path
        d="M19,15.21c-0.0613,0.96 -0.5767,1.79 -1.3374,2.29c0.2515,-0.58 0.4172,-1.28 0.4601,-2.07c0.0061,-0.12 0.1043,-0.22 0.227,-0.22z"
        fill="#1A8B5A"
      />
      <path
        d="M15.7914,12h0.2086c-0.0675,0 -0.1411,0 -0.2086,0.01z"
        fill="#1A8B5A"
      />
      <path
        d="M16.2086,12v0.01c-0.0675,-0.01 -0.1411,-0.01 -0.2086,-0.01z"
        fill="#1A8B5A"
      />
      <path
        d="M15.7914,17.99c0.0675,0.01 0.1411,0.01 0.2086,0.01h-0.2086z"
        fill="#1A8B5A"
      />
      <path
        d="M16.2086,17.99v0.01h-0.2086c0.0675,0 0.1411,0 0.2086,-0.01z"
        fill="#1A8B5A"
      />
    </svg>
  );
};

export default WebsiteCMSIcon;
